import SurveyAddItems from './SurveyAddItems';
import './SurveyAddItems.scss';

export default SurveyAddItems;
